import { ATMGeneralInfo } from 'commons/types/DTO/commons'

import { ATMGeneralInfoFormValue } from '../../../../types/forms'

export const mapATMGeneralInfoForm = (formValues: ATMGeneralInfoFormValue): ATMGeneralInfo => ({
  ...formValues
})
